export default "__VITE_ASSET__CFGV_KgR__"